// extracted by mini-css-extract-plugin
module.exports = {"container":"Skeleton__container___3EixF"};